export default {
  fleetSuppliers: [],
  fleetSupplier: undefined,
};
